var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRidgeFeatureSelectionOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "#272D55",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 13.2266H5C4.44772 13.2266 4 13.6743 4 14.2266V19.3436C4 19.8958 4.44772 20.3436 5 20.3436H7C7.55228 20.3436 8 19.8958 8 19.3436V14.2266C8 13.6743 7.55228 13.2266 7 13.2266Z",
    fill: "#272D55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 13.7266H5C4.72386 13.7266 4.5 13.9504 4.5 14.2266V19.3436C4.5 19.6197 4.72386 19.8436 5 19.8436H7C7.27614 19.8436 7.5 19.6197 7.5 19.3436V14.2266C7.5 13.9504 7.27614 13.7266 7 13.7266Z",
    stroke: "#272D55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.16016H10C9.44772 9.16016 9 9.60787 9 10.1602V19.3442C9 19.8964 9.44772 20.3442 10 20.3442H12C12.5523 20.3442 13 19.8964 13 19.3442V10.1602C13 9.60787 12.5523 9.16016 12 9.16016Z",
    fill: "#AECDFC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 9.66016H10C9.72386 9.66016 9.5 9.88401 9.5 10.1602V19.3442C9.5 19.6203 9.72386 19.8442 10 19.8442H12C12.2761 19.8442 12.5 19.6203 12.5 19.3442V10.1602C12.5 9.88401 12.2761 9.66016 12 9.66016Z",
    stroke: "#272D55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17 5.09375H15C14.4477 5.09375 14 5.54147 14 6.09375V19.3438C14 19.896 14.4477 20.3438 15 20.3438H17C17.5523 20.3438 18 19.896 18 19.3438V6.09375C18 5.54147 17.5523 5.09375 17 5.09375Z",
    fill: "#AECDFC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17 5.59375H15C14.7239 5.59375 14.5 5.81761 14.5 6.09375V19.3438C14.5 19.6199 14.7239 19.8438 15 19.8438H17C17.2761 19.8438 17.5 19.6199 17.5 19.3438V6.09375C17.5 5.81761 17.2761 5.59375 17 5.59375Z",
    stroke: "#272D55"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M1.2998 1.90039V20.1004",
    stroke: "#272D55",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 20.0996H1.3",
    stroke: "#272D55",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRidgeFeatureSelectionOperationIcon);
export default __webpack_public_path__ + "static/media/RidgeFeatureSelectionOperationIcon.647daaf1abc9279ee73b1ebf9e560f28.svg";
export { ForwardRef as ReactComponent };